<template>
  <div>
    <div class="mt-5 search-container w-100" :style="{ 'font-size': '14px' }">
      <select
        class="search-input primary-border "
        :style="{
          border: '1px solid ' + getPrimaryColor(),
          background: 'white !important'
        }"
        @change="handleQuestionType"
        v-model="category"
      > 
        <option
          :value="category.key_name"
          v-for="category in categories"
          :key="category.id"
        >
          {{ category.display_name }}
        </option>
      </select>
      <input
        type="search"
        class="search-input-state primary-border "
        placeholder="Search Question"
        :style="{
          border: '1px solid ' + getPrimaryColor(),
          background: 'white !important',
          'border-radius': '0px'
        }"
        v-model="query"
      />
      <button
        type="submit"
        :disabled="!this.category"
        class="search-button primary-border font-white primary-button"
        :style="{
          background: getPrimaryColor(),
          border: '1px solid ' + getPrimaryColor(),
          flex: 1
        }"
        @click="searchQuestions()"
      >
        <a-icon class="svg-icon-size" type="search" :size="'large'" />
      </button>
    </div>
  </div>
</template>

<script>
import Question from "../../Users/Patient/QA/Question";
import { mapGetters } from "vuex";
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";
import { eventBus } from "../../../main";

const QARepository = RepositoryFactory.get("qa");

export default {
  name: "SearchQA",
  components: {
    Question
  },
  data() {
    return {
      query: "",
      category: null,
      pagination: null,
      currentPage: 1,
      limit: 5,
      categories: []
    };
  },

  computed: {
    ...mapGetters({
      questions: "QA/getSearchQuestions"
    })
  },

  created() {
    this.init();

    eventBus.$on("refresh-qa-search-questions", () => {
      console.log("insde evnt bus");
      this.limit += 5;
      //this.query ? this.searchQuestions() : this.init();
      this.searchQuestions();
    });
  },

  methods: {
    init() {
      QARepository.getQuestionCategories()
        .then(res => {
          this.categories.push(...res.data.data);
          this.category = "All";
          console.log(this.category, res, "cat");
          this.searchQuestions();
        })
        .catch(err =>
          // QARepository.getAllQuestions(
          //   this.currentCircle.id,
          //   this.currentPage,
          //   this.limit
          // )
          //   .then(res => {
          //     //
          //     this.$store.commit('QA/setSearchQuestions', {
          //       data: res.data.data.data,
          //       pagination: res.data.data.paginator
          //     })
          //     this.currentPage = 1
          //   })
          //   .catch(err =>
          this.searchQuestions()
        );
    },

    handleQuestionType(e) {
      this.category = e.target.value;
      this.searchQuestions();
    },

    searchQuestions(append = false) {
      this.currentPage = 1;
      this.$store.commit("QA/setIsFetchingData", { data: true });
      let selectedCat =
        this.category.toLowerCase() === "all" ? "" : this.category;
      QARepository.searchQuestions(
        this.query,
        selectedCat,
        this.currentPage,
        this.limit,
        this.currentCircle.id
      )
        .then(res => {
          if (res.status === 204) {
            this.$store.commit("QA/setSearchQuestions", {
              data: [],
              pagination: {}
            });
            this.$store.commit("QA/setIsFetchingData", { data: false });
          }
          if (res.data) {
            this.$store.commit("QA/setSearchQuestions", {
              data: res.data.data.data,
              pagination: res.data.data.paginator
            });
            this.$store.commit("QA/setIsFetchingData", { data: false });
          }

          // this.currentPage += 1
        })
        .catch(err => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.search-container {
  display: flex;

  .search-input {
    padding: 10px;
    border-radius: 8px 0 0 8px;
    width: 50%;
    &:focus {
      outline: none;
    }
  }
  .right-small-radius {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  .left-small-radius {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    // background: white;
  }

  .search-input-state {
    border-left: 0 !important;
    padding: 10px;
    // width: 350px;
    width: 50%;

    &:focus {
      outline: none;
    }
  }

  .search-button {
    max-width: 100px;
    border-radius: 0 8px 8px 0;

    &:focus {
      outline: none;
    }
  }
}
@media screen and (max-width: 581px) {
  .search-container {
    display: flex;
    flex-direction: column;

    .search-input {
      width: 100%;
      margin-bottom: 5px;
      border-radius: 8px;
      &-state {
        width: 100%;
        border-radius: 8px;
        margin-bottom: 5px;
      }
    }

    .search-button {
      border-radius: 8px;
      min-width: 100%;
    }
  }

  .filters-cont {
    .row {
      flex-direction: column;

      &-name {
        max-width: 100%;
      }

      &-city {
        max-width: 100%;
      }

      &-speciality {
        max-width: 100%;
      }
    }
  }

  .gender-section {
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/QA/SearchQA.vue